import { render, staticRenderFns } from "./AutoTerminal.vue?vue&type=template&id=3b4376a4&scoped=true"
import script from "./AutoTerminal.vue?vue&type=script&lang=js"
export * from "./AutoTerminal.vue?vue&type=script&lang=js"
import style0 from "./AutoTerminal.vue?vue&type=style&index=0&id=3b4376a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4376a4",
  null
  
)

export default component.exports